app.controller('OrganizationalPositionsAddController', [
    '$scope', '$stateParams', 'Position', 'params', '$state', '$uibModalInstance', 'ConfirmModal', 'toastr',
    function ($scope, $stateParams, Position, params, $state, $uibModalInstance, ConfirmModal, toastr) {
        $scope.action = params.name ? 'რედაქტირება' : 'დამატება';
        $scope.unitId = $stateParams.unit;
        $scope.positioId = params.id;
        $scope.name = params.name || null;
        $scope.description = params.description || null;
        $scope.isRoot = params.isRoot || null;


        $scope.submit = function () {
            if(params.name) $scope.edit();
            else $scope.create();
        };

        $scope.createPosition = function () {
            Position.create({
                name: $scope.name,
                description: $scope.description,
                organization: $scope.unitId,
                isRoot: $scope.isRoot
            }).then(function () {
                toastr.success('თანამდებობა დამატებულია');
                $uibModalInstance.close();
            });
        };

        $scope.editPosition = function () {
            Position.edit({
                _id: $scope.positioId,
                name: $scope.name,
                description: $scope.description,
                organization: $scope.unitId,
                isRoot: $scope.isRoot
            }).then(function (resp) {
                toastr.success('თანამდებობა რედაქტირებულია');
                $uibModalInstance.close();
            });
        };


        $scope.create = function () {
            if (!$scope.name) {
                toastr.error('', 'გთხოვთ მიუთითოთ თანამდებობის სახელი');
                return;
            }

            else if ($scope.isRoot) {
                ConfirmModal.show({
                    title: "ყურადღება",
                    message: "გსურთ დამატებული თანამდებობა გახადოთ ორგანიზაციის მმართველი?"
                }).result.then(function () {
                    $scope.createPosition();
                });
            }
            else $scope.createPosition();
        };

        $scope.edit = function () {
            if (!$scope.name) {
                toastr.error('', 'გთხოვთ მიუთითოთ თანამდებობის სახელი');
                return;
            }

            else if ($scope.isRoot) {
                ConfirmModal.show({
                    title: "ყურადღება",
                    message: "გსურთ თანამდებობა გახადოთ ორგანიზაციის მმართველი?"
                }).result.then(function () {
                    $scope.editPosition();
                });
            }
            else $scope.editPosition();
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };


    }]);
